import { render, staticRenderFns } from "./ForumHome.vue?vue&type=template&id=14041c64&scoped=true&"
import script from "./ForumHome.vue?vue&type=script&lang=js&"
export * from "./ForumHome.vue?vue&type=script&lang=js&"
import style0 from "./ForumHome.vue?vue&type=style&index=0&id=14041c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14041c64",
  null
  
)

export default component.exports